

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const stockOpeningAtomList = atom({key:'stockOpeningAtom', default:{stock_opening_info:[],
    warehouse:[]
}});

const stockOpeningEditAtom = atom({key:'stockOpeningEditAtom', default:{opening_main: [],
    opening_details: []}});




export  const SetStockOpeningList = () => useSetRecoilState(stockOpeningAtomList);
export  const GetStockOpeningList = () => useRecoilValue(stockOpeningAtomList);

export  const SetStockOpeningEdit = () => useSetRecoilState(stockOpeningEditAtom);
export  const GetStockOpeningEdit = () => useRecoilValue(stockOpeningEditAtom);
export const ResetOpenStockEdit = ()=> useResetRecoilState(stockOpeningEditAtom);









